const NotFoundPage = () => {
    return (
        <div>
            <h1>404,当前页面存在</h1>
        </div>
    )
}

export default NotFoundPage
